/* global window */
const URLS = window.URLS || {};
const minMaxValues = window.minMaxValues || {};
const COLORS = window.COLORS || {};

export const API_URL = URLS.API_URL || 'http://localhost:8000/api/';
export const LOGIN_URL = URLS.LOGIN_URL || 'http://localhost:8000/accounts/google/login/?next=/client';
export const LOGOUT_URL = URLS.LOGOUT_URL || 'http://localhost:8000/accounts/logout/?next=/account/';
export const PROJECT_WEBSITE_URL = URLS.PROJECT_WEBSITE_URL || 'http://elephant-project.science';
export const USER_URL = URLS.USER_URL || 'http://localhost:8000/account/';
export const IMAGE_URL = URLS.IMAGE_URL || 'http://localhost:8000/images/photo_db/';
export const LOCATION_IMAGE_URL = URLS.LOCATION_IMAGE_URL || 'http://localhost:8000/images/maps_db/';

export const maxNumberOfRecents = 5;
export const systolicBloodPressurePk = 23;
export const diastolicBloodPressurePk = 24;
export const defaultMeasureCodeIdsToDisplay = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export const defaultAdvancedSearchFilter = { target: 'self', attribute: 'num', value: 0 };
export const advancedSearchFilterOrder = [
  'num',
  'name',
  'sex',
  'age',
  'lifespan',
  'birth',
  'captive',
  'offspring count',
  'alive',
  'measured count',
];
export const minAndMaxValues = minMaxValues.values
  || [
    { pk: 10, min: 2.2, max: 4.3 },
    { pk: 12, min: 28, max: 40 },
    { pk: 13, min: 9.4, max: 13.5 },
    { pk: 14, min: 3.8, max: 5.3 },
    { pk: 15, min: 123, max: 133 },
    { pk: 16, min: 87, max: 96 },
    { pk: 17, min: 8300, max: 21500 },
    { pk: 18, min: 15, max: 46 },
    { pk: 19, min: 13, max: 42 },
    { pk: 20, min: 21, max: 54 },
    { pk: 21, min: 0, max: 10 },
    { pk: 23, min: 107, max: 158 },
    { pk: 24, min: 71, max: 122 },
    { pk: 27, min: 2.5, max: 5.7 },
    { pk: 28, min: 8.5, max: 10.7 },
    { pk: 29, min: 5, max: 25 },
    { pk: 30, min: 0.7, max: 1.6 },
    { pk: 31, min: 6.6, max: 8.6 },
    { pk: 32, min: 2.5, max: 3.4 },
    { pk: 33, min: 3.8, max: 5.4 },
    { pk: 34, min: 0, max: 63 },
    { pk: 35, min: 37, max: 201 },
    { pk: 37, min: 0, max: 61 },
    { pk: 38, min: 21, max: 399 },
  ];
export const plotColors = COLORS.PLOT_COLORS || ['red', 'blue'];
export const minMaxPlotColors = COLORS.MIN_MAX_PLOT_COLORS || ['rgb(255, 100, 100)', 'rgb(100, 100, 255)'];



// WEBPACK FOOTER //
// ./src/config.jsx